import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  API_INITIATE_GET_AMS_CUSTOMER_DATA,
  API_COMPLETE_GET_AMS_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_AMS_CUSTOMER_DATA,
  API_INITIATE_POST_AMS_OPTIMIZE_PLAN_DATA,
  API_COMPLETE_POST_AMS_OPTIMIZE_PLAN_DATA,
  API_INITIATE_SUBMIT_AMS_CUSTOMER_DATA,
} from '../../app-constants';
import View from './ams-homepage.presenter';
import { submitAMSCustomerData, submitAMSOptimizePlanData } from './ams-homepage.actions';
// Reducer
export const amsHomePageReducer = (state = {
  loading: false,
  dataLoaded: false,
  formSubmitted: false,
  customerAccountName: '',
  customerAccountNumber: '',
  customerAbn: '',
  getData: '',
  referenceNumber: '',
  alreadySubmitted: false,
  optimizeInProgress: false,
  submissionInProgress: false,
  loadedOptimizeData: false,
  optimizePlanData: '',
}, action) => {
  switch (action.type) {
    case API_INITIATE_GET_AMS_CUSTOMER_DATA:
      return { ...state, loading: true, dataLoaded: false, formSubmitted: false };
    case API_INITIATE_SUBMIT_AMS_CUSTOMER_DATA:
      return { ...state, formSubmitted: false, submissionInProgress: true };
    case API_COMPLETE_SUBMIT_AMS_CUSTOMER_DATA:
      return { ...state, loading: false, formSubmitted: true, submissionInProgress: false };
    case API_COMPLETE_GET_AMS_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        dataLoaded: true,
        customerAccountName: action.data.accountName,
        customerAccountNumber: action.data.accountNumber,
        customerAbn: action.data.abn,
        getData: action.data,
        alreadySubmitted: action.data.alreadySubmitted,
      };
    }
    case API_INITIATE_POST_AMS_OPTIMIZE_PLAN_DATA:
      return { ...state, optimizeInProgress: true };
    case API_COMPLETE_POST_AMS_OPTIMIZE_PLAN_DATA:
      return { ...state, optimizeInProgress: false, optimizePlanData: action.data, loadedOptimizeData: true };
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  customerAccountNumber: state.amsHomePageReducer.customerAccountNumber,
  customerAccountName: state.amsHomePageReducer.customerAccountName,
  customerAbn: state.amsHomePageReducer.customerAbn,
  authorableContent: state.authorableContentReducer.authorableContent,
  dataLoaded: state.amsHomePageReducer.dataLoaded,
  getData: state.amsHomePageReducer.getData,
  formSubmitted: state.amsHomePageReducer.formSubmitted,
  referenceNumber: state.amsHomePageReducer.referenceNumber,
  alreadySubmitted: state.amsHomePageReducer.alreadySubmitted,
  optimizePlanData: state.amsHomePageReducer.optimizePlanData,
  optimizeInProgress: state.amsHomePageReducer.optimizeInProgress,
  loadedOptimizeData: state.amsHomePageReducer.loadedOptimizeData,
  submissionInProgress: state.amsHomePageReducer.submissionInProgress,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitAMSCustomerData,
    submitAMSOptimizePlanData,
  }, dispatch),
});

const AMSHomePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);


export default AMSHomePage;
